<div class="layout-nav-top" *ngIf="isLoggedIn() && !hideProductContent && isUserDataLoaded">
  <app-header class="app-header"></app-header>
  <app-page-header title="{{layout.pageHeader.pageTitle}}" icon="{{layout.pageHeader.pageIcon}}"
    iconLink="{{layout.pageHeader.iconLink}}" [confirmDialogRequired]="layout.pageHeader.confirmDialogRequired">
  </app-page-header>
  <p-breadcrumb *ngIf="layout.breadcrumbItems.length !== 0" [model]="layout.breadcrumbItems"></p-breadcrumb>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <app-footer class="app-footer"></app-footer>
</div>

<app-loading [hidden]="!loading"></app-loading>

<p-dialog [(visible)]="openAccessDeniedDialog" [modal]="true" (onHide)="closeErrorDialog()">
  <p-header>
    <i class="ei ei-warning orange"></i>Access not granted
  </p-header>
  <div class="m-b-12">
    You have not been granted access for Product management module.
    <br>
    Please contact your superior / admin to get access
  </div>
  <p-footer>
    <div class="text-right">
      <button pButton class="p-button" type="button" label="Ok" (click)="closeErrorDialog()">
      </button>
    </div>
  </p-footer>
</p-dialog>